module.exports = __webpack_public_path__ + "media/images/favicon/favicon-f7ae9a62b1613d128993cd5cfa3e9063.ico";